/**
 * Development Logger Utility
 * Only logs messages when REACT_APP_DEV_MODE is explicitly set to 'true'
 * In production, all logs are silenced
 */

const isDev = process.env.REACT_APP_DEV_MODE === 'true';

export const logger = {
    log: (...args) => {
        if (isDev) console.log(...args);
    },
    warn: (...args) => {
        if (isDev) console.warn(...args);
    },
    error: (...args) => {
        if (isDev) console.error(...args);
    },
    info: (...args) => {
        if (isDev) console.info(...args);
    },
    debug: (...args) => {
        if (isDev) console.debug(...args);
    }
};

export default logger;
